export default __webpack_public_path__ + "static/banner_mobile-bcc5a33079d8914ed99f855abf6d2cdf.png";